import React from 'react';
import FilterAndList from './UI/List/FilterAndList';

export default function PunchCard() {
    return <FilterAndList />;
}
